import { defineMessage } from 'magpie-lib/models';
import * as t from 'ts-schema';
export const conversationResolvedPublishMessage = defineMessage({
  type: '@assistant/conversation-resolved',
  payloadSchema: t.object({
    conversationId: t.number,
    correlationId: t.string
  })
});